import { ZeroValueAs } from "../../../../../../../../../../../api/types/fieldConfigurationTypes";
import NumberFormatRadioGroup from "./NumberFormatRadioGroup";

interface Props {
  value: ZeroValueAs | undefined;
  onZeroValueChanged: (showAs: ZeroValueAs) => void;
}

const zeroValueOptions = [
  { label: "\u00AB 0 \u00BB", value: ZeroValueAs.Zero },
  { label: "\u00AB - \u00BB", value: ZeroValueAs.Dash },
  { label: "Empty", value: ZeroValueAs.Empty },
];

const ZeroValue = ({ value, onZeroValueChanged }: Props) => {
  return (
    <NumberFormatRadioGroup
      value={value}
      label="Show zero values as"
      options={zeroValueOptions}
      onValueChanged={onZeroValueChanged}
    />
  );
};

export default ZeroValue;
